/* Imports */
import axios from 'axios';

export default {
  state: {
    filters: [],
    categoryUrls: {},
    hasFilters: true,
  },
  getters: {
    getFilters: (state) => state.filters,
    getCategoryUrls: (state) => state.categoryUrls,
    getHasFilters: (state) => state.hasFilters,
  },
  mutations: {
    setFilters: (state, value) => {
      // eslint-disable-next-line no-param-reassign
      state.filters = value.filters;
    },
    setCategoryUrl: (state, { categoryId, url }) => {
      // eslint-disable-next-line no-param-reassign
      state.categoryUrls = {
        ...state.categoryUrls,
        [categoryId]: url,
      };
    },
    setHasFilters: (state, value) => {
      // eslint-disable-next-line no-param-reassign
      state.hasFilters = value;
    },
  },
  actions: {
    loadHasFilters: async ({ commit }, value) => {
      commit('setHasFilters', value);
    },
    fetchCategoryUrlById: async ({ state, commit, getters }, categoryId) => {
      if (!categoryId) return '';
      if (state.categoryUrls[categoryId]) return state.categoryUrls[categoryId];
      const locale = getters.getLocale;

      const url = `${window?.location?.origin}${getters.getPublicPath}/api/getUrlSlugByCategoryId?categoryId=${categoryId}&locale=${locale}`;
      const response = await axios.get(url);

      if (response.status !== 200) {
        throw new Error(`Received ${response.status}: ${response.statusText}`);
      }

      const {
        urlSlug,
      } = response?.data || {};
      const categoryUrl = `${window?.location?.origin}/${locale}/c${urlSlug}`;
      commit('setCategoryUrl', {
        categoryId,
        url: categoryUrl,
      });

      return categoryUrl;
    },
    loadFilters: async ({ commit, getters, dispatch }) => {
      const filteredQueryParams = Object.entries(getters.getQueryParams)
        .filter(([key]) => key === 'series'
          || /^[A-Z][A-Z0-9_]+$/.test(key)
          || /^productFilter.+$/.test(key))
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

      const queryObject = {
        ...filteredQueryParams,
        cg: getters.getCustomerGroups?.split('|')?.join('_') || '',
        categoryKey: getters.getCategoryKey,
        locale: getters.getLocale,
        storeCode: getters.getStoreCode,
        appName: 'www-category-pages',
      };
      // TODO: Remove conditional once NETFE-19709 is released and ITFE_CATEGORY_PAGES_ENABLE_NEW_FILTERS_API flag is deleted
      const urlPath = getters.getContentfulEnvSettings?.ITFE_CATEGORY_PAGES_ENABLE_NEW_FILTERS_API ? 'getCategoryFilters' : 'getFilters';

      const queryString = new URLSearchParams(queryObject).toString();
      const url = `${window?.location?.origin}${getters.getPublicPath}/api/${urlPath}?${queryString}`;
      const response = await axios.get(url);

      if (response.status !== 200) {
        throw new Error(`Received ${response.status}: ${response.statusText}`);
      }

      const data = response?.data || {};

      // Fetch category URLs for filters with category keys in parallel,
      // continue even if some fail
      const categoryKeyPromises = [];
      data.filters.forEach((filter) => {
        if (filter.id === 'ECOMMERCE_FILTER_CATEGORIES') {
          filter.options.forEach((option) => {
            if (option.categoryKey) {
              categoryKeyPromises.push(
                dispatch('fetchCategoryUrlById', option.categoryKey),
              );
            }
          });
        }
      });

      if (categoryKeyPromises?.length > 0) {
        await Promise.allSettled(categoryKeyPromises);
      }

      commit('setFilters', data);
    },
  },
};
